import { allowListIsNotActive } from '../../dropHelpers.js'
import { syncWithMetaMask } from '../wallet.js'

export default function(client, _web3modal) {
  const proofClient = client.proof()

  const state = {
    account: {
      address: "",
      isConnected: false
    },
    proof: []
  }

  const actions = {
    async connectWallet() {
      // Prefer direct MetaMask sync when an injected MetaMask provider exists
      if (typeof window !== 'undefined' && window.ethereum && window.ethereum.isMetaMask) {
        await syncWithMetaMask()
        return
      }

      // Fallback to AppKit modal (WalletConnect / other wallets), which is
      // especially important for mobile browsers without an injected provider
      if (_web3modal) {
        _web3modal.open()
      }
    },
    async getProofByDrop({commit, state, rootState}) {
      const drop = rootState.drops.dropDetail

      if(!state.account.isConnected || allowListIsNotActive(drop)) {
        commit('setProof', [])
        return
      }

      const {proof} = await proofClient.getByAccountAndDropId(state.account.address, drop.id)
      commit('setProof', proof)
    },
    async setAccount({ commit }, account) {
      commit('setAccountState', account)
    }
  }

  const mutations = {
    setAccountState(state, account) {
      state.account.address = account.address
      state.account.isConnected = account.isConnected
    },
    setProof(state, proof) {
      state.proof = proof
    }
  }

  return {
    namespaced: true,
    state,
    actions,
    mutations
  }
}
